import styled from "styled-components";

const Row = styled.div`
  display: contents;
  color: ${({ theme }) => theme.old.colors.gray[100]};

  & > :first-child {
    padding-left: 24px;
  }

  & > :last-child {
    padding-right: 24px;
  }
`

export default Row;
